import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UtButtonComponent, type UtButtonVariant, UtIconComponent, type UtIconName} from '../../../ui';

@Component({
  selector: 'app-login-choice-button',
  template: `
    <ut-button [variant]="variant" [fullWidth]="true" (clicked)="selected.emit()">
      <div class="btn-contents">
        <div class="logo-wrapper">
          @if (logoImage) {
            <img [src]="logoImage" />
          }
          @if (logoIcon) {
            <ut-icon [name]="logoIcon"></ut-icon>
          }
        </div>
        <div class="text">{{ text }}</div>
      </div>
    </ut-button>
  `,
  styleUrls: ['./login-choice-button.component.scss'],
  imports: [UtButtonComponent, UtIconComponent],
})
export class LoginChoiceButtonComponent {
  @Input() logoImage?: string;
  @Input() logoIcon?: UtIconName;
  @Input() text: string = '';
  @Input() variant: UtButtonVariant = 'secondary';
  @Output() selected = new EventEmitter();
}
